import React, { useState } from 'react'
import { Form } from '~/lib/ui/form'
import { DatePickerField } from '~/components/shared/DatePickerField'
import { TextareaField } from '~/components/surveys/TextareaField'
import { Button } from '~/lib/ui/button'
import { SpinnerWhite } from '~/components/shared/Spinner'
import { useReminderForm } from './useReminderForm'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import useTranslation from '../shared/TranslationProvider'

const ReminderDialog = ({ reminder = null, asChild, children }) => {
  const { t, locale } = useTranslation('ReminderDialog')
  const [isOpen, setIsOpen] = useState(false)
  const onSuccess = () => {
    setIsOpen(false)
  }

  const onOpenChange = (open) => {
    setIsOpen(open)
  }

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger className="cursor-pointer" asChild={asChild}>
        {children}
      </DialogTrigger>
      <DialogContent
        className="site-info-dialog max-w-xl font-roboto"
        aria-describedby={undefined}
      >
        <DialogHeader>
          <DialogTitle className="font-roboto-slab text-xl tracking-[0.12px]">
            {t('set_your_reminder')}
          </DialogTitle>
        </DialogHeader>
        <ReminderForm
          reminder={reminder}
          locale={locale}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  )
}
export default ReminderDialog

const ReminderForm = ({ reminder, onSuccess, locale }) => {
  const { t } = useTranslation('ReminderDialog')
  const { form, onSubmit, isPending } = useReminderForm({
    reminder,
    onSuccess,
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="mb-4 ml-4 mr-4">
        <DatePickerField
          name="due_date"
          id="reminder_due_date"
          label={t('reminder_due_date')}
          disabled={(date) =>
            date < new Date() || date > new Date('2100-01-01')
          }
          control={form.control}
          pickDate={t('pick_a_date')}
          locale={locale}
        />
        <TextareaField
          name="content"
          id="reminder_content"
          className="w-full"
          label={t('share_your_thoughts')}
          placeholder={t('remember_to_placeholder')}
          control={form.control}
        />
        <div className="flex w-full flex-row justify-end">
          <Button disabled={isPending} type="submit">
            {isPending ? t('saving') : t('save')}
            <SpinnerWhite show={isPending} className="pl-4" />
          </Button>
        </div>
      </form>
    </Form>
  )
}
